import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'
import { METRIC_DATA_KEYS } from '~/api/query/earnings'

export const earnings = createQueryKeys('earnings', {
  metric: (widgetName: METRIC_DATA_KEYS, query?: any) => [widgetName, query],
})

export type CountryKeys = inferQueryKeys<typeof earnings>
